import { ParseNumber, onCount, subMixStr, isAllElectric } from '@/utils/basicUtil'
import { Notify } from 'vant'

/**
 * 计算秘籍口诀
 * 仅有金额
 * 填数量反算单价 填单价反算数量
 * 金额数量单价均无
 * 正算金额
 * 金额数量单价均有
 * 删金额，反清单价
 * 删单价，反清金额
 * 删数量，反清金额
 * 改金额，反算单价
 * 改单价，正算金额
 * 改数量，正算金额
*/
export class InvoiceCal {
  constructor(props) {
    console.log(props)
    this.data = this.initData(props.data, props.invoiceType)
    this.invoiceType = props.invoiceType
  }
  data = null
  invoiceType = null
  lenTestMap = new Map([
    ['unitPrice', { text: '不含税单价' }],
    ['unitPriceWithTax', { text: '含税单价' }],
    ['quantity', { text: '数量' }],
  ])
  isSpecial = () => {
    if (this.invoiceType === 1 || this.invoiceType === 4) {
      return true
    }
    return false
  }

  initData = (oldData, invoiceType) => {
    const data = { ...oldData }
    if (isAllElectric(invoiceType)) {
      try {
        this.lenTestMap.forEach((item, field) => {
          const maxNum = data[field] ? data[field].toString().indexOf('.') !== -1 ? 16 : 15 : 15
          if (data[field] && data[field].toString().length > maxNum) {
            data[field] = subMixStr(data[field].toString(), maxNum)
            throw new Error(`数电${item.text}小数点前后合计位数不能超过15位!`)
          }
        })
      } catch (e) {
        Notify({ type: 'danger', message: e.message })
      }
    }
    return data
  }

  changeUnitPrice() {
    console.log('这里是计算修改了不含税单价的逻辑')
    // 没金额 有数量， 正算金额
    // 数量、金额都有， 正算金额
    // 有金额 没数量， 反算数量
    // 删单价，反清金额
    const data = this.data
    const unitPrice = ParseNumber(data.unitPrice)
    const amount = ParseNumber(data.amount)
    const quantity = data.quantity
    if (unitPrice === null) {
      data.amount = null
    } else {
      if ((quantity && !amount) || (quantity && amount)) {
        if (quantity > 0) {
          data.amount = onCount.mul(quantity, unitPrice).toFixed(2)
        } else if (quantity < 0) {
          data.amount = onCount.mul(Number(onCount.mul(Math.abs(quantity), unitPrice).toFixed(2)), -1).toFixed(2)
        }
      } else if (!quantity && amount) {
        data.quantity = this.toFixed(onCount.div(amount, unitPrice))
      }
    }
    this.calculateDataWithTax()
    this.calculateTaxAmount()
  }
  changeUnitPriceWithTax() {
    console.log('这里是计算修改了含税单价的逻辑')
    // 没金额 有数量， 正算金额
    // 数量、金额都有， 正算金额
    // 有金额 没数量， 反算数量
    // 删单价，反清金额
    const data = this.data
    const unitPriceWithTax = ParseNumber(data.unitPriceWithTax)
    const amountWithTax = ParseNumber(data.amountWithTax)
    const quantity = data.quantity
    if (unitPriceWithTax === null || unitPriceWithTax === '') {
      data.amountWithTax = null
    } else {
      if ((quantity && !amountWithTax) || (quantity && amountWithTax)) {
        if (quantity > 0) {
          data.amountWithTax = onCount.mul(quantity, unitPriceWithTax).toFixed(2)
        } else if (quantity < 0) {
          data.amountWithTax = onCount.mul(Number(onCount.mul(Math.abs(quantity), unitPriceWithTax).toFixed(2)), -1).toFixed(2)
        }
      } else if (!quantity && amountWithTax) {
        data.quantity = this.toFixed(onCount.div(amountWithTax, unitPriceWithTax))
      }
    }
    this.calculateData()
    this.calculateTaxAmount()
  }
  changeQuantity(notRevenueCode) {
    console.log('这里是计算修改了数量的逻辑，当前是不含税的界面')
    // 没金额 有单价， 正算金额
    // 金额、单价都有，正算金额
    // 有金额 没单价， 反算单价
    // 删数量，反清金额
    const data = this.data
    const quantity = data.quantity
    const unitPrice = ParseNumber(data.unitPrice)
    const amount = ParseNumber(data.amount)
    if (!data.revenueCode && !notRevenueCode) {
      return
    }
    if (quantity === null || quantity === '') {
      data.amount = null
      data.amountWithTax = null
      return
    }
    if ((unitPrice && !amount) || (unitPrice && amount)) {
      if (quantity > 0) {
        data.amount = onCount.mul(quantity, unitPrice).toFixed(2)
      } else if (quantity < 0) {
        data.amount = onCount.mul(Number(onCount.mul(Math.abs(quantity), unitPrice).toFixed(2)), -1).toFixed(2)
      }
    } else if (amount && !unitPrice) {
      data.unitPrice = this.toFixed(onCount.div(amount, quantity))
    }
    if (notRevenueCode) return
    this.calculateDataWithTax()
    this.calculateTaxAmount()
  }
  changeQuantityWithTax(notRevenueCode) {
    console.log('这里是计算修改了数量的逻辑，当前是含税的界面')
    // 没金额 有单价， 正算金额
    // 金额、单价都有，正算金额
    // 有金额 没单价， 反算单价
    // 删数量，反清金额
    const data = this.data
    const quantity = data.quantity
    const unitPriceWithTax = ParseNumber(data.unitPriceWithTax)
    const amountWithTax = ParseNumber(data.amountWithTax)
    if (!data.revenueCode && !notRevenueCode) {
      return
    }
    if (quantity === null || quantity === '') {
      data.amount = null
      data.amountWithTax = null
      return
    }
    if ((unitPriceWithTax && !amountWithTax) || (unitPriceWithTax && amountWithTax)) {
      if (quantity > 0) {
        data.amountWithTax = onCount.mul(quantity, unitPriceWithTax).toFixed(2)
      } else if (quantity < 0) {
        data.amountWithTax = onCount.mul(Number(onCount.mul(Math.abs(quantity), unitPriceWithTax).toFixed(2)), -1).toFixed(2)
      }
    } else if (amountWithTax && !unitPriceWithTax) {
      data.unitPriceWithTax = onCount.div(amountWithTax, quantity)
    }
    if (notRevenueCode) return
    this.calculateData()
    this.calculateTaxAmount()
  }
  changeAmount() {
    // 数量单价都无，直接填入
    // 数量单价都有 反算单价
    // 有数量没单价，反算单价
    // 没数量有单价，反算数量
    // 删金额，反清单价
    console.log('这里是计算修改了不含税金额的逻辑')
    const data = this.data
    const quantity = data.quantity
    const unitPrice = ParseNumber(data.unitPrice)
    if (data.amount === null || data.amount === '') { // 删除金额逻辑
      data.unitPrice = null
    } else {
      data.amount = Number(data.amount).toFixed(2)
      const amount = ParseNumber(data.amount)
      if (quantity) {
        data.unitPrice = this.toFixed(onCount.div(amount, quantity))
      } else if (!quantity && unitPrice) {
        data.quantity = this.toFixed(onCount.div(amount, unitPrice))
      }
    }
    this.calculateDataWithTax()
    this.calculateTaxAmount()
  }
  changeAmountWithTax() {
    // 数量单价都无，直接填入
    // 数量单价都有 反算单价
    // 有数量没单价，反算单价
    // 没数量有单价，反算数量
    // 删金额，反清单价
    console.log('这里是计算修改了含税金额的逻辑')
    const data = this.data
    const quantity = data.quantity
    const unitPriceWithTax = ParseNumber(data.unitPriceWithTax)
    if (data.amountWithTax === null) {
      data.unitPriceWithTax = null
    } else {
      data.amountWithTax = ParseNumber(data.amountWithTax) ? ParseNumber(data.amountWithTax).toFixed(2) : ParseNumber(data.amountWithTax)
      const amountWithTax = ParseNumber(data.amountWithTax)
      if (quantity) {
        data.unitPriceWithTax = this.toFixed(onCount.div(amountWithTax, quantity))
      } else if (!quantity && unitPriceWithTax) {
        data.quantity = this.toFixed(onCount.div(amountWithTax, unitPriceWithTax))
      }
    }
    this.calculateData()
    this.calculateTaxAmount()
  }
  changeOuterDiscountAmountWithTax() {
    console.log('这里是计算修改了折扣金额（含税）的逻辑')
    const data = this.data
    if ( data.outerDiscountAmountWithTax === null) {
      data.outerDiscountAmount = null
    } else {
      const outerDiscountAmountWithTax = ParseNumber(data.outerDiscountAmountWithTax)
      data.outerDiscountAmount = Number(onCount.div(outerDiscountAmountWithTax, onCount.add(1, data.taxRate || 0))).toFixed(2)
      data.outerDiscountTaxAmount = Number(onCount.sub(outerDiscountAmountWithTax, ParseNumber(data.outerDiscountAmount))).toFixed(2)
    }
  }
  changeOuterDiscountAmount() {
    console.log('这里是计算修改了折扣金额（不含税）的逻辑')
    const data = this.data
    if ( data.outerDiscountAmount === null ) {
      data.outerDiscountAmountWithTax = null
    } else {
      const outerDiscountAmount = ParseNumber(data.outerDiscountAmount)
      data.outerDiscountAmountWithTax = Number(onCount.mul(outerDiscountAmount, onCount.add(1, data.taxRate || 0))).toFixed(2)
      data.outerDiscountTaxAmount = Number(onCount.sub(data.outerDiscountAmountWithTax, ParseNumber(outerDiscountAmount))).toFixed(2)
    }
  }
  changeTaxRate() {
    console.log('这里是计算修改了税率的逻辑')
    const data = this.data
    if (data.taxRate === '免税') {
      if (this.isSpecial() ) {
        Notify({ type: 'danger', message: '专票不能开具免税的货物' })
        return
      } else {
        data.taxPre = 0
        data.taxPreType = 1
        data.taxRate = 0
      }
    } else {
      data.taxPre = 1 // 1 不享受优惠政策
      data.taxPreType = 0 // 1 免税 2 不征税 0 不享受
    }
    this.calculateDataWithTax()
    this.calculateTaxAmount()
    this.changeOuterDiscountAmount()
  }
  changeTaxRateWithTax() {
    console.log('这里是计算修改了税率的逻辑')
    this.calculateData()
    this.calculateTaxAmount()
    this.changeOuterDiscountAmountWithTax()
  }
  calculateTaxAmount() {
    console.log('这里是得到金额后，自动计算税额的逻辑,必须保证有金额（含税）和金额（不含税）')
    const data = this.data
    const amount = ParseNumber(data.amount)
    const amountWithTax = ParseNumber(data.amountWithTax)
    if (amount > 0) {
      data.taxAmount = Number(onCount.sub(amountWithTax, amount)).toFixed(2)
    } else if (amount < 0) {
      data.taxAmount = onCount.mul(Number(Number(onCount.sub(Math.abs(amountWithTax), Math.abs(amount))).toFixed(2)), -1)
    } else {
      data.taxAmount = 0
    }
  }
  calculateDataWithTax() {
    console.log('这里是由不含税计算含税的逻辑')
    const data = this.data
    const amount = ParseNumber(data.amount)
    const unitPrice = ParseNumber(data.unitPrice)
    const taxRate = ParseNumber(data.taxRate)
    if (amount === null || amount === '') {
      data.amountWithTax = null
    } else {
      data.amountWithTax = Number(onCount.mul(amount, onCount.add(1, taxRate))).toFixed(2)
    }
    if (unitPrice === null || unitPrice === '') {
      data.unitPriceWithTax = null
    } else {
      data.unitPriceWithTax = this.toFixed(onCount.mul(unitPrice, onCount.add(1, taxRate)))
    }
  }
  calculateData() {
    console.log('这里是由含税计算不含税的逻辑')
    const data = this.data
    const amountWithTax = ParseNumber(data.amountWithTax)
    const unitPriceWithTax = ParseNumber(data.unitPriceWithTax)
    const taxRate = ParseNumber(data.taxRate)
    if (amountWithTax === null || amountWithTax === '') {
      data.amount = null
    } else {
      data.amount = Number(onCount.div(amountWithTax, onCount.add(1, taxRate))).toFixed(2)
    }

    if (unitPriceWithTax === null || unitPriceWithTax === '') {
      data.unitPrice = null
    } else {
      data.unitPrice = this.toFixed(onCount.div(unitPriceWithTax, onCount.add(1, taxRate)))
    }
  }
  /**
   * 优化toFixed方法，自动保留除掉小数点总共加起来15位的逻辑
   */
  toFixed(number) {
    let n = 15;
    if (isNaN(number) || number >= Math.pow(10, 21)) {
      return number.toString();
    }
    if (typeof (n) === 'undefined' || n === 0) {
      return (Math.round(number)).toString();
    }

    let result = number.toString();
    const arr = result.split('.');
    // 整数的情况 单价金额，不补0
    if (arr.length < 2) {
      return result;
    }

    const integer = arr[0];
    const decimal = arr[1];
    n = n - integer.toString().length
    if (decimal.length === n) {
      return result;
    }
    if (decimal.length < n) {
      return result;
    }
    result = integer + '.' + decimal.substr(0, n);
    const last = decimal.substr(n, 1);

    // 四舍五入，转换为整数再处理，避免浮点数精度的损失
    if (parseInt(last, 10) >= 5) {
      const x = Math.pow(10, n);
      result = (Math.round((parseFloat(result) * x)) + 1) / x;
      result = result.toFixed(n);
    }
    return result;
  }

  getUnitPrice(value) {
    if (!value) return value
    if (isAllElectric(this.invoiceType)) {
      try {
        const stringValue = value.toString()
        const maxNum = stringValue.indexOf('.') !== -1 ? 16 : 15
        console.log(Number(subMixStr(stringValue, maxNum)) || 0, '截取后')
        return Number(subMixStr(stringValue, maxNum)) || 0
      } catch (e) {
      }
    }
    return value
  }

  getResult() {
    return {
      ...this.data,
      unitPriceWithTax: this.getUnitPrice(this.data.unitPriceWithTax),
      unitPrice: this.getUnitPrice(this.data.unitPrice),
      quantity: this.getUnitPrice(this.data.quantity)
    }
  }
}
